var _path, _circle, _path2, _path3, _circle2, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelinsuranceRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.92,331.29H263.17a5.87,5.87,0,0,1-5.86-5.86V62.16a5.87,5.87,0,0,1,5.86-5.86H443.92a5.87,5.87,0,0,1,5.86,5.86V325.43A5.87,5.87,0,0,1,443.92,331.29ZM263.17,56.55a5.61,5.61,0,0,0-5.61,5.61V325.43a5.61,5.61,0,0,0,5.61,5.61H443.92a5.61,5.61,0,0,0,5.61-5.61V62.16a5.61,5.61,0,0,0-5.61-5.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.49,331.29H54.75a5.87,5.87,0,0,1-5.87-5.86V62.16a5.87,5.87,0,0,1,5.87-5.86H235.49a5.86,5.86,0,0,1,5.86,5.86V325.43A5.86,5.86,0,0,1,235.49,331.29ZM54.75,56.55a5.62,5.62,0,0,0-5.62,5.61V325.43A5.62,5.62,0,0,0,54.75,331H235.49a5.61,5.61,0,0,0,5.61-5.61V62.16a5.61,5.61,0,0,0-5.61-5.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 392.36,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.6,
    y: 403.11,
    width: 53.53,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.98,
    y: 415.11,
    width: 36.25,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.59,
    y: 402.98,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.69,
    y: 402.98,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.45,
    y: 409.21,
    width: 53.89,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 405.53,
    width: 16.06,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.05,148.61,84.9,131.79,40.75,148.61c-.84,1.68,0,72.74,44.15,88.72C129.05,221.35,129.89,150.29,129.05,148.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.52,154.74l-36.62-14-36.62,14c-.7,1.39,0,60.34,36.62,73.6C121.52,215.08,122.22,156.13,121.52,154.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.44 198.35 68.14 184.9 72.84 178.86 84.44 187.88 101.03 168.91 106.79 173.94 85.44 198.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.95 464.31 81.46 464.31 88.03 391.97 41.38 391.97 47.95 464.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,404c.93-30.18-6.48-92.45-18.53-116.66l.83-.4C59,312.14,66,374.1,65.17,404Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.93,307.25c-11.33,8.88-14.4,37.86-14.4,37.86C68.56,331.84,81,325.54,74.93,307.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4,345.55a.44.44,0,0,1-.31-.48c.12-1.19,3.21-29.27,14.56-38.18a.44.44,0,0,1,.41-.08.45.45,0,0,1,.31.3c4.56,13.73-1.1,20.79-7.65,28.95a84.65,84.65,0,0,0-6.79,9.29.45.45,0,0,1-.4.22Zm.87-2.45c1.82-2.77,3.8-5.23,5.71-7.62,6.29-7.83,11.73-14.61,7.71-27.45C65.77,315.68,62.16,336.46,61.27,343.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.88,302.62c13.56,4.72,25.61,31.51,25.61,31.51C46.6,324.18,33.06,321.87,32.88,302.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.53,334.5A93.45,93.45,0,0,0,49.46,328c-8.87-5.78-16.55-10.78-16.68-25.42a.48.48,0,0,1,.2-.37.45.45,0,0,1,.42-.06c13.63,4.75,25.38,30.68,25.87,31.78a.46.46,0,0,1,0,.2.46.46,0,0,1-.46.45A.55.55,0,0,1,58.53,334.5ZM50,327.24c2.49,1.62,5.05,3.29,7.58,5.26-2.94-6-12.89-24.84-23.84-29.23C34.08,316.88,41.46,321.68,50,327.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.14,334.92c-14.07,10.66-18.7,51-18.7,51C74.55,369.82,90.18,357.47,83.14,334.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25,386.43a.58.58,0,0,1-.38-.61c.2-1.66,4.84-40.67,18.92-51.33a.57.57,0,0,1,.52-.09.53.53,0,0,1,.37.37c5.62,18-2.83,29.38-11.78,41.48-2.35,3.2-4.82,6.51-7,9.94a.54.54,0,0,1-.48.26Zm1.08-3c1.82-2.72,3.8-5.34,5.66-7.9,8.63-11.67,16.8-22.71,11.85-39.66C71.59,345.33,66.6,374.71,65.33,383.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.61,329.34c16.54,6.09,32.2,34.82,32.2,34.82C48.48,351.71,30.39,352.94,30.61,329.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.44,364.59c-4.43-3.85-9.16-6.34-13.75-8.76C38.6,350.51,29.88,345.91,30,329.34a.56.56,0,0,1,.77-.53c16.55,6.11,31.88,33.89,32.51,35.07a.55.55,0,0,1-.13.71.5.5,0,0,1-.37.13A.64.64,0,0,1,62.44,364.59ZM31.17,330.17c.16,15.22,8.46,19.6,18.09,24.66a81.06,81.06,0,0,1,11.56,6.95c-4.29-7.08-16.72-26.27-29.65-31.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.47,289.39c-7.9,6.2-10,26.41-10,26.41C61,306.55,69.71,302.15,65.47,289.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.29,316.1a.32.32,0,0,1-.21-.34c.12-.83,2.28-20.42,10.19-26.64a.35.35,0,0,1,.3-.05.32.32,0,0,1,.21.21c3.18,9.58-.77,14.5-5.35,20.2A61.4,61.4,0,0,0,55.71,316a.33.33,0,0,1-.27.15A.26.26,0,0,1,55.29,316.1Zm.65-1.7c1.28-1.93,2.65-3.65,4-5.32,4.39-5.46,8.16-10.18,5.38-19.14C59.09,295.29,56.6,309.78,55.94,314.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.55,302.39a63.74,63.74,0,0,0-6.33-4.51c-6.2-4-11.56-7.53-11.65-17.73a.32.32,0,0,1,.14-.27.39.39,0,0,1,.3,0c9.49,3.33,17.69,21.41,18.05,22.18a.35.35,0,0,1-.11.39.31.31,0,0,1-.19.06A.3.3,0,0,1,51.55,302.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Earth--inject-158--inject-87"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 387.24,
    cy: 93.1,
    r: 57.88,
    transform: "matrix(0.17, -0.99, 0.99, 0.17, 230.21, 459.12)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.53 121.51 346.53 121.01 345.64 120.22 345.61 118.36 346.46 117.68 346.44 116.64 347.12 116.47 347.22 115.72 348.84 116.05 346.75 113.52 345.64 113.91 344.61 113.22 344.84 112.34 343.93 111.75 345.35 110.39 345.62 109.33 347.31 108.43 346.63 107 347.25 106.59 347.23 105.6 349.25 106.13 349.73 106.96 351.73 109.28 351.95 110.81 352.53 111.82 352.56 112.57 353.21 113.23 353.26 115.23 352.64 115.52 352.65 116 352.04 116.99 350.98 120.58 349.75 120.65 349.21 121.52 346.53 121.51",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.17 44.67 371.79 43.96 372.98 41.16 373.76 41.65 374.07 41.28 373.19 40.01 373.86 39.06 373.8 38.46 374.97 37.84 377.24 38.42 378.04 38.43 378.5 38.88 380.52 38.45 380.54 39.28 381.45 39.52 380.61 41.42 379.81 42.31 380.13 43.28 377.02 45.44 376.47 46.05 373.99 45.92 373.64 46.82 372.56 47.11 371.17 44.67",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.71 49.84 400.74 49.06 402.56 49.54 402.1 51.32 400.34 52.77 399.25 51.62 399.71 49.84",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.57 60.79 415.09 60.38 415.35 59.79 416.07 59.22 416.62 59.16 417.19 58.7 417.5 59.38 418.48 59.77 418.63 61.84 420.52 61.83 420.63 63.38 420.04 63.68 419.9 64.25 418.29 63.83 417.39 64.33 417.73 64.8 417.37 65.02 417.54 65.27 416.5 65.81 416.36 65.62 415.99 65.84 415.21 65.52 414.45 65.95 414.08 65.56 413.53 65.71 413.19 64.58 411.68 64.19 411.42 63.82 410.62 63.61 409.41 61.92 409.52 61.17 409.09 60.58 409.73 60 410.6 60.11 411.29 60.53 411.81 60.47 412.57 60.8 412.98 61.59 413.38 61.39 413.86 61.55 414.57 60.79",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.88 80.6 439.66 79.93 441.84 81.02 443.12 83.56 442.79 84.64 443.22 85.53 442.75 87.35 442 87.21 441.33 88.15 438.9 87.52 439.53 85.09 437.63 84.21 437.62 81.85 436.88 80.6",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.09 57.03 407.63 58.64 406.92 61.4 404.7 62.38 404.45 61.92 403.77 61.83 403.21 59.68 402.86 59.04 403.33 58.76 403.6 58.06 405.02 57.17 405.76 57.24 406.09 57.03",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.83 46.06 366.86 45.63 368.02 46.54 368.35 50 367.6 49.98 366.29 50.7 364.48 50.62 363.92 49.83 362.87 49.79 360.73 48.02 362.01 46.19 363.08 46.54 363.83 46.06",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.09 38.34 388.19 39.58 389.01 42.41 386.73 43.52 383.73 42.74 384.57 39.5 386.09 38.34",
    style: {
      fill: "#e6e6e6",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.83,465.09c0,3.39-83.49,6.13-186.48,6.13s-186.47-2.74-186.47-6.13S138.37,459,241.35,459,427.83,461.7,427.83,465.09Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Airplane--inject-87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Plane--inject-2--inject-87"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.32 56.31 160.65 53.87 165.28 54.78 157.32 59.53 148.32 56.31",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.32 56.31 160.65 53.87 165.28 54.78 157.32 59.53 148.32 56.31",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.05,40.43l18.69-7.51a15.52,15.52,0,0,1,8.66-.81l3.58.7L102.3,45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.05,40.43l18.69-7.51a15.52,15.52,0,0,1,8.66-.81l3.58.7L102.3,45Z",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.14,37.14a2.51,2.51,0,0,0,.4,3.53A18.36,18.36,0,0,0,59,44.8l95.88,18.77,3.69-2.64-.89-4.08L63,35.33a18.32,18.32,0,0,0-8.52.21l-2.87.71A2.49,2.49,0,0,0,50.14,37.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.93,
    y: 49.43,
    width: 0.52,
    height: 42.41,
    transform: "translate(34.03 183.3) rotate(-78)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.08,
    y: 28.63,
    width: 0.52,
    height: 27.64,
    transform: "translate(60.13 159.15) rotate(-78)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.98,
    y: 72.2,
    width: 0.52,
    height: 11.36,
    transform: "translate(53.91 222.34) rotate(-78)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.16,43l.35.17A19.07,19.07,0,0,0,59,44.72l95.88,18.77a4.21,4.21,0,0,0,1.37,0,3.56,3.56,0,0,0-1.22-.47l-93.63-20A18.35,18.35,0,0,0,54.16,43Z",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.96 59.11 156.38 70.11 161.01 71.02 158.6 60.85 147.96 59.11",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.56 54.59 159.01 45.76 163.33 46.61 157.71 56.77 146.56 54.59",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.92,44.64,92.55,71A15.33,15.33,0,0,0,103,78.58h0l-1.56-29.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.06,
    y: 53.4,
    width: 2.2,
    height: 1.2,
    transform: "translate(47.92 166.75) rotate(-78.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.68,
    y: 52.94,
    width: 2.2,
    height: 1.2,
    transform: "translate(46.48 164.06) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.3,
    y: 52.46,
    width: 2.2,
    height: 1.2,
    transform: "translate(45.05 161.33) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.91,
    y: 51.97,
    width: 2.2,
    height: 1.2,
    transform: "translate(43.63 158.61) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.52,
    y: 51.48,
    width: 2.2,
    height: 1.2,
    transform: "translate(42.2 155.88) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.13,
    y: 50.99,
    width: 2.2,
    height: 1.2,
    transform: "translate(40.77 153.15) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.74,
    y: 50.5,
    width: 2.2,
    height: 1.2,
    transform: "translate(39.33 150.41) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.35,
    y: 49.97,
    width: 2.2,
    height: 1.2,
    transform: "translate(37.91 147.63) rotate(-78.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.96,
    y: 49.52,
    width: 2.2,
    height: 1.2,
    transform: "translate(36.47 144.94) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.58,
    y: 49.02,
    width: 2.2,
    height: 1.2,
    transform: "translate(35.05 142.21) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.19,
    y: 48.52,
    width: 2.2,
    height: 1.21,
    transform: "translate(33.63 139.47) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.81,
    y: 48.05,
    width: 2.2,
    height: 1.2,
    transform: "translate(32.2 136.76) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.41,
    y: 47.52,
    width: 2.2,
    height: 1.2,
    transform: "translate(30.78 133.98) rotate(-78.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.02,
    y: 47.05,
    width: 2.2,
    height: 1.21,
    transform: "translate(29.34 131.27) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.63,
    y: 46.57,
    width: 2.2,
    height: 1.21,
    transform: "translate(27.9 128.55) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.25,
    y: 46.09,
    width: 2.2,
    height: 1.2,
    transform: "translate(26.47 125.82) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.86,
    y: 45.58,
    width: 2.2,
    height: 1.21,
    transform: "translate(25.05 123.08) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.47,
    y: 45.1,
    width: 2.2,
    height: 1.21,
    transform: "translate(23.61 120.36) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 44.62,
    width: 2.2,
    height: 1.2,
    transform: "translate(22.19 117.64) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.69,
    y: 44.09,
    width: 2.2,
    height: 1.2,
    transform: "translate(20.78 114.85) rotate(-78.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 43.64,
    width: 2.2,
    height: 1.21,
    transform: "translate(19.32 112.17) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.91,
    y: 43.15,
    width: 2.2,
    height: 1.2,
    transform: "translate(17.89 109.43) rotate(-78.42)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.9,36.51l8.53,1.74a1.1,1.1,0,0,0,.42-2.16l-4.23-.82c-.4.07-.79.17-1.18.27l-2.87.71A3,3,0,0,0,50.9,36.51Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.25,185.94a20.15,20.15,0,1,0-32.12,8.3l.08,6,5.9-2.45.31.13A20.15,20.15,0,0,0,440.25,185.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.51,175a.24.24,0,0,1-.24-.22,19.81,19.81,0,0,0-10.6-15.29.25.25,0,0,1-.11-.33.25.25,0,0,1,.34-.12,20.31,20.31,0,0,1,10.86,15.69.24.24,0,0,1-.22.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.64,181h-.06a.25.25,0,0,1-.18-.3,7.12,7.12,0,0,0,.08-2.87.24.24,0,0,1,.2-.29.24.24,0,0,1,.29.2,7.61,7.61,0,0,1-.09,3.08A.25.25,0,0,1,443.64,181Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421 187.87 411.77 180.99 414.17 177.77 420.36 182.38 428.87 172.23 431.95 174.81 421 187.87",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 83.45,
    width: 270.32,
    height: 376.73,
    rx: 7.43,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.82,
    y: 121.02,
    width: 250.68,
    height: 325.07,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.27,
    y: 97.28,
    width: 250.68,
    height: 338.88,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,123.75h18.3a4.45,4.45,0,0,1,4.45,4.45v18.3a4.44,4.44,0,0,1-4.44,4.44H142.1a4.45,4.45,0,0,1-4.45-4.45V128.2A4.44,4.44,0,0,1,142.1,123.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85,133.48h-3.14v-1.85h8.54v1.85h-3.13v8h-2.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.72,141.44l-1.89-2.74h-2.09v2.74h-2.27v-9.81h4.24a5.47,5.47,0,0,1,2.27.44,3.37,3.37,0,0,1,0,6.21l2.19,3.16Zm-.58-7.52a2.39,2.39,0,0,0-1.55-.44h-1.85v3.42h1.85a2.33,2.33,0,0,0,1.55-.45,1.75,1.75,0,0,0,0-2.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.22,139.34h-4.55l-.87,2.1h-2.32l4.37-9.81h2.24l4.38,9.81h-2.38Zm-.71-1.73L197,133.86l-1.55,3.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38,131.63l-4.24,9.81H205.9l-4.23-9.81h2.45l3,7,3-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.79,139.62v1.82H213.2v-9.81h7.4v1.82h-5.15v2.13H220v1.77h-4.55v2.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.59,131.63h2.27v8h4.92v1.85h-7.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,131.63h2.27v9.81H235Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.6,131.63v9.81h-1.87l-4.88-6v6h-2.24v-9.81h1.87l4.88,6v-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.89,141.29a5.22,5.22,0,0,1-1.74-.82l.77-1.71a5,5,0,0,0,1.5.74,5.55,5.55,0,0,0,1.74.28,2.75,2.75,0,0,0,1.42-.28.89.89,0,0,0,.47-.77.72.72,0,0,0-.28-.58,2,2,0,0,0-.7-.37c-.28-.09-.67-.2-1.15-.31a14.36,14.36,0,0,1-1.84-.53,3,3,0,0,1-1.22-.85,2.33,2.33,0,0,1-.51-1.57,2.71,2.71,0,0,1,.46-1.55,3.12,3.12,0,0,1,1.39-1.1,5.7,5.7,0,0,1,2.28-.41,7.52,7.52,0,0,1,1.83.23,5.44,5.44,0,0,1,1.57.64l-.7,1.73a5.38,5.38,0,0,0-2.72-.77,2.58,2.58,0,0,0-1.4.3.94.94,0,0,0-.46.82.79.79,0,0,0,.53.74,7.74,7.74,0,0,0,1.6.49,15.37,15.37,0,0,1,1.83.53,3.08,3.08,0,0,1,1.23.84,2.25,2.25,0,0,1,.51,1.55,2.71,2.71,0,0,1-.47,1.54,3.13,3.13,0,0,1-1.41,1.1,5.71,5.71,0,0,1-2.28.4A8.09,8.09,0,0,1,251.89,141.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94,140.44a4.46,4.46,0,0,1-1.17-3.32v-5.49H262V137c0,1.75.73,2.63,2.18,2.63a2,2,0,0,0,1.63-.64,3,3,0,0,0,.56-2v-5.41h2.24v5.49a4.46,4.46,0,0,1-1.17,3.32,5.19,5.19,0,0,1-6.54,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.14,141.44l-1.89-2.74h-2.09v2.74h-2.27v-9.81h4.24a5.47,5.47,0,0,1,2.27.44,3.37,3.37,0,0,1,0,6.21l2.19,3.16Zm-.58-7.52a2.39,2.39,0,0,0-1.55-.44h-1.85v3.42H275a2.33,2.33,0,0,0,1.55-.45,1.77,1.77,0,0,0,0-2.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.64,139.34h-4.55l-.87,2.1H279.9l4.36-9.81h2.24l4.39,9.81h-2.38Zm-.71-1.73-1.56-3.75-1.55,3.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.9,131.63v9.81H299l-4.89-6v6h-2.24v-9.81h1.88l4.87,6v-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.21,141a4.8,4.8,0,0,1-1.91-1.8,5.3,5.3,0,0,1,0-5.23,4.8,4.8,0,0,1,1.91-1.8,5.56,5.56,0,0,1,2.72-.66,5.65,5.65,0,0,1,2.3.45A4.55,4.55,0,0,1,312,133.2l-1.45,1.35A3.14,3.14,0,0,0,308,133.4a3.22,3.22,0,0,0-1.62.4,2.7,2.7,0,0,0-1.11,1.11,3.5,3.5,0,0,0,0,3.25,2.76,2.76,0,0,0,1.11,1.11,3.22,3.22,0,0,0,1.62.4,3.15,3.15,0,0,0,2.47-1.16l1.45,1.34a4.5,4.5,0,0,1-1.73,1.31,5.91,5.91,0,0,1-2.31.44A5.54,5.54,0,0,1,305.21,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.08,139.62v1.82h-7.59v-9.81h7.41v1.82h-5.15v2.13h4.55v1.77h-4.55v2.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.65,
    y: 166.06,
    width: 193.01,
    height: 10.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.65,
    y: 240.08,
    width: 193.01,
    height: 10.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.65,
    y: 405.66,
    width: 193.01,
    height: 10.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.65,
    y: 190.57,
    width: 193.01,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.65,
    y: 206.7,
    width: 193.01,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.65,
    y: 222.84,
    width: 193.01,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.65,
    y: 269.21,
    width: 193.01,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.22,
    y: 290.07,
    width: 157.44,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.22,
    y: 304.77,
    width: 157.44,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73,309.36H139.26V282.89h26.47Zm-25.47-1h24.47V283.89H140.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.22,
    y: 329.75,
    width: 157.44,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.22,
    y: 344.45,
    width: 157.44,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73,349H139.26V322.57h26.47Zm-25.47-1h24.47V323.57H140.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.22,
    y: 369.43,
    width: 157.44,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.22,
    y: 384.13,
    width: 157.44,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73,388.72H139.26V362.24h26.47Zm-25.47-1h24.47V363.24H140.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,132.81c1.28-1.48,4.58-.55,6.85.66,0,0,1.56.74,2.14,1.12h0l5.3-.66a2.24,2.24,0,0,1,1.25.22l.44.22a.29.29,0,0,1,0,.53l-3.9,1.67v0l3.85,2.53.06,0a3.4,3.4,0,0,0,2.45.49l2.06-.37a.55.55,0,0,1,.31,0,.52.52,0,0,1,.14.88l-2.39,2a1.25,1.25,0,0,1-1.34.17l-1.12-.51-5.65-2.7.65,3.23a.22.22,0,0,1-.22.25h-.27a1.1,1.1,0,0,1-.88-.54l-2.28-4.35-6.67-3.18C140.66,134.16,140.34,133.4,140.78,132.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.77 306.24 141.83 295.85 145.45 290.99 154.8 297.95 167.65 282.63 172.29 286.52 155.77 306.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.77 345.06 141.83 334.68 145.45 329.81 154.8 336.77 167.65 321.45 172.29 325.35 155.77 345.06",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.77 383.88 141.83 373.5 145.45 368.64 154.8 375.6 167.65 360.27 172.29 364.17 155.77 383.88",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.28,
    y: 76.93,
    width: 85.75,
    height: 32.34,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.3 80.2 211.16 80.2 205.57 55.57 268.17 55.57 261.3 80.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.05,55.57c-.06.15-6.68,21.08-6.52,21.08h5.69l6-21.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.49,76.93s-.41,32.35,0,32.35H277V76.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.68,237.66,334,278.31l-23.46,24.85,5.19,4.47s22.55-15.49,28.84-24.07c5.88-8,16.85-34,16.85-34Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.56,303.16c-2.95.33-4.83-.45-8.25-1.38a9.32,9.32,0,0,0-1.61-.49,1,1,0,0,0-1,.64,2,2,0,0,0,.58,1.43,10.61,10.61,0,0,0,3.35,2,9.7,9.7,0,0,0-3.19,2.55,3.12,3.12,0,0,0-.63,1.9,1.35,1.35,0,0,0,1.3,1.28,2.47,2.47,0,0,0,2,2.27c.27.79.81,1.63,1.63,1.67a3,3,0,0,1,.85,0c.25.1.41.34.62.5.68.56,1.7.25,2.52-.11,3.26-1.44,4.88-5,7-7.87",
    style: {
      fill: "#b97964"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.3,308.15a8.07,8.07,0,0,1,8.05,8.06V409a8.06,8.06,0,0,1-8.05,8h-8.6a8.07,8.07,0,0,1-8.06-8V316.21a8.07,8.07,0,0,1,8.06-8.06h8.6m0-1.55h-8.6a9.65,9.65,0,0,0-9.61,9.61V409a9.64,9.64,0,0,0,9.61,9.6h8.6a9.63,9.63,0,0,0,9.6-9.6V316.21A9.64,9.64,0,0,0,302.3,306.6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 319.59,
    cy: 466.65,
    r: 3.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.42,466.65a3.65,3.65,0,1,1-3.7-3.6h0A3.65,3.65,0,0,1,310.42,466.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.45,466.65a3.64,3.64,0,1,1-3.64-3.64A3.64,3.64,0,0,1,289.45,466.65Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.99,
    cy: 466.65,
    r: 3.64
  })), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 369,
    width: 61.39,
    height: 95.34,
    rx: 4.77,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 369,
    width: 61.39,
    height: 95.34,
    rx: 4.77,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.88,
    y: 369,
    width: 55.59,
    height: 95.34,
    rx: 4.77,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.88,
    y: 369,
    width: 55.59,
    height: 95.34,
    rx: 4.77,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,455.14h0a2.34,2.34,0,0,1-2.34-2.34V384.48a2.34,2.34,0,0,1,2.34-2.34h0a2.34,2.34,0,0,1,2.34,2.34V452.8A2.34,2.34,0,0,1,274,455.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.36,455.14h0A2.34,2.34,0,0,1,283,452.8V384.48a2.34,2.34,0,0,1,2.34-2.34h0a2.34,2.34,0,0,1,2.34,2.34V452.8A2.34,2.34,0,0,1,285.36,455.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.68,455.14h0a2.34,2.34,0,0,1-2.34-2.34V384.48a2.34,2.34,0,0,1,2.34-2.34h0a2.34,2.34,0,0,1,2.34,2.34V452.8A2.34,2.34,0,0,1,296.68,455.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,455.14h0a2.34,2.34,0,0,1-2.34-2.34V384.48a2.34,2.34,0,0,1,2.34-2.34h0a2.34,2.34,0,0,1,2.34,2.34V452.8A2.34,2.34,0,0,1,308,455.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.69,305.81a8.54,8.54,0,0,1,7.74,3.78,1.8,1.8,0,0,1,.38,1.46,1.85,1.85,0,0,1-1.13,1c-.65.3-.07-.63-.76-.45-.36.09-1.16-.36-1.53-.45a1.83,1.83,0,0,1-1-.66c-1.14-1.21-3.05-1-3.78-2.53"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M309.44,314.3a3.43,3.43,0,0,0,1.25-.8,1.21,1.21,0,0,0,.2-1.39,1.16,1.16,0,0,0-.91-.47,2.83,2.83,0,0,0-1,.21,8.27,8.27,0,0,0-1.36.69,5.13,5.13,0,0,0,1-.84,1.61,1.61,0,0,0,.4-1.21.87.87,0,0,0-.26-.51,1.2,1.2,0,0,0-1.08-.11,5.36,5.36,0,0,0-2.11,1.11,8.35,8.35,0,0,1,.92-1,2.45,2.45,0,0,0,.73-1.1,1.11,1.11,0,0,0-.35-1.2,1.47,1.47,0,0,0-1.24-.19,6.13,6.13,0,0,0-1.81.9,5.1,5.1,0,0,0,1.29-1.37,1,1,0,0,0,.19-.47c0-.33-.31-.57-.62-.69a2.64,2.64,0,0,0-1.91.15,6.33,6.33,0,0,0-2.48,2.14s1.35,1.32,1.46,1.39l6.38,4.46Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.18,
    y: 251.31,
    width: 1,
    height: 76.88,
    transform: "translate(-77.06 169.05) rotate(-21.27)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,362.46c-7.44-1.61-15.18-.82-22.71.31-14.31,2.13-28.56,5.46-41.64,11.64-15.84,2.1-37.89,2.14-42,8.13,40.9,16.74,89.27-1.15,107.8-12.46,1.52-.93,3.2-2.25,3.1-4C451.27,364,448.89,362.9,446.86,362.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M446.86,362.46c-7.44-1.61-15.18-.82-22.71.31-14.31,2.13-28.56,5.46-41.64,11.64-15.84,2.1-37.89,2.14-42,8.13,40.9,16.74,89.27-1.15,107.8-12.46,1.52-.93,3.2-2.25,3.1-4C451.27,364,448.89,362.9,446.86,362.46Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M398.85,237.66s3,.81,5.92,6.83c2,4.15,12.47,27.92,13.28,32,1.28,6.32,1.83,42.51,1.83,42.51h-6.52s-6.47-38.38-6.6-38.77-14.4-28.75-14.4-28.75Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.21,398.4c-2.72-4.57-7.5-9.08-9.28-12.9-1.56-3.3-1.38-5.89-4-13.77-3.17-9.55-8.18-22-14.79-30.43,0,0,4.56-14.46-6.94-25.9l-7.55-7.19-28.78,7.92,43.7,74.06,41.5,61,7.77-3.32C444.14,433.69,434.76,411.73,427.21,398.4Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.24,366.12l-18.72,11v3L395,382.5l1.65,2.8s3.89-2.65,8-5.25,10-6.26,10-6.26Z",
    style: {
      opacity: 0.2
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M443.7,472.64a13.8,13.8,0,0,1,2-3.79h0s1.28-5.22-3.24-14.07l3.66-4.44a5.57,5.57,0,0,1,4.85-2,2.19,2.19,0,0,1,.64.21,19.63,19.63,0,0,1,2.41,2.05,69.52,69.52,0,0,1,6.77,8.23l-.81.69-4.51-5c-1.47-1.74-1.65,1.87-.62,4.18s1.62,5.28-3.41,9.52C445.7,473.11,443.1,475,443.7,472.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.68,448.66a115,115,0,0,1,4.84,12.06,18.82,18.82,0,0,1,1.16,8.17s4.22-2.62,4.29-5.92-3.07-11.82,1.07-14.64a8.57,8.57,0,0,0-2.23-.45l-1.23-2.55C445.23,446.31,439.68,448.66,439.68,448.66Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.77,254.12l7.35-15.35c-3.31-5-19.71-8.75-19.71-8.75l-10.8.59s-4.16.93-7.71,2.09c-4.75,1.55-7.31,2.79-8.45,5.42,0,0-2.27,5.87-.79,17.86.41,3.32,1.53,22.5-1.5,28l.06,1.52c19.74,15.37,36.44,12.8,36.44,12.8-.89-2.72-.8-11.67-1.2-14.32a58.39,58.39,0,0,1,1.6-11.89C388.33,271,392.29,255.23,392.77,254.12Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76,224.11c.92-8.54-5.31-6.44-4.49-17.36.89-12-10.54-15-10.54-15s-4-5.28-9.43-6.76c-7-1.89-24.94,2.73-20.82,17.92,2.45,9.06.95,8.69-.41,12.48-1.93,5.36,2.7,12.71-2.4,16,0,0,19.61-.4,40.58.81C391.25,232.13,398.2,229.32,398.76,224.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.09,231.74a41.64,41.64,0,0,0-7.82,5.43,15,15,0,0,1-2.93,2c-2.83,1.51-5.4,2.36-6.1,1a4.44,4.44,0,0,1-.37-1c-.59-2.28-.34-5.49,1.5-7,2.08-1.66,3.08-3.07,2.71-5.31a16.83,16.83,0,0,0-1.2-3.86l2.41-1.44,8.56-8.64C378.87,218.3,378.58,228.6,383.09,231.74Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.15,227.43c2.35-1.4,4.93-3.82,4.62-6.59a12.54,12.54,0,0,0-.66-3l-4.79,6.33A15.52,15.52,0,0,1,370.15,227.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.5,203.26c-.8,8.8-1,12.52-5.5,17.14-6.82,6.93-17.33,4.6-19.13-4.12-1.63-7.84,0-20.91,8.59-24.61A11.31,11.31,0,0,1,381.5,203.26Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.11,206.12c0,.93-.55,1.7-1.12,1.71s-1-.73-1-1.66.54-1.7,1.12-1.71S370.15,205.19,370.11,206.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,206.1c-.05.9-.55,1.64-1.13,1.65s-1-.71-1-1.61.55-1.64,1.12-1.65S361.48,205.19,361.44,206.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,202.88a.41.41,0,0,1-.32-.1,3.19,3.19,0,0,0-2.89-.81.39.39,0,0,1-.51-.29.47.47,0,0,1,.32-.54,3.94,3.94,0,0,1,3.68,1,.44.44,0,0,1,0,.61A.41.41,0,0,1,372,202.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.52,201.68a.31.31,0,0,1-.2-.19.47.47,0,0,1,.22-.56,3.66,3.66,0,0,1,3.56-.24.4.4,0,0,1,.1.56.43.43,0,0,1-.55.18,2.92,2.92,0,0,0-2.82.22A.38.38,0,0,1,358.52,201.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.8,205.67a30,30,0,0,1-2.93,5.34.68.68,0,0,0,.32,1,4.38,4.38,0,0,0,2.36,0Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.47,204.5l-2-.48S368.56,205.53,369.47,204.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.68,204.51l-2-.48S359.77,205.53,360.68,204.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.45,206.3s-4.54-6.83-4.3-12.36c0,0-8.69-2.27-15.61,7-1.11,1.47-1.76,3.93-2.75,6,0,0-1.66-16.74,13.19-18.11s17.74,19.48,10.51,26.49A10.9,10.9,0,0,0,378.45,206.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.16,210.43a7.05,7.05,0,0,1-4.27,3.32c-2.33.59-3.53-3.16-2.74-5.49a4.68,4.68,0,0,1,5.27-3C384.65,205.68,385.35,208.37,384.16,210.43Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.25,210.21h0a.25.25,0,0,1-.23-.27,3.43,3.43,0,0,1,1.16-2.36,3.54,3.54,0,0,1,2.49-.85.25.25,0,0,1,.23.27.23.23,0,0,1-.26.23,3,3,0,0,0-2.13.73,3,3,0,0,0-1,2A.23.23,0,0,1,379.25,210.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.36,215a4,4,0,0,1-.81-.08.26.26,0,0,1-.2-.3.25.25,0,0,1,.3-.19,2.72,2.72,0,0,0,3.18-1.62.25.25,0,1,1,.46.17A3.23,3.23,0,0,1,366.36,215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.38,308.89l-3.23,75.51,2.59,73.17,9.1,2.34c4-14.46,7.3-42.88,8.24-57.7.22-5.08-1.42-10.94-.85-14.94.5-3.52,2.14-5.75,4.29-13.73,2.6-9.66,5.23-22.58,4.18-32.58,0,0,12.22-11,8.6-25.56Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15,384.4s3.55-3.38,10.08-2.4,9.62,2.63,9.62,2.63l1.77-4.93-15-4.24-6.5,3.22Z",
    style: {
      opacity: 0.2
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M335.28,474.78a14.48,14.48,0,0,1,4-1.59h0s4.35-3.16,6.6-12.83l5.65-1a5.58,5.58,0,0,1,5,1.56,2.14,2.14,0,0,1,.35.57,19.6,19.6,0,0,1,.52,3.11,69.1,69.1,0,0,1-.13,10.67h-1.06l-.25-6.7c0-2.28-2.47.37-3.17,2.8s-2.17,5.08-8.75,5.08C336.51,476.43,333.32,476.18,335.28,474.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.94,456.89a90.8,90.8,0,0,1-3.35,9.31,18.81,18.81,0,0,1-4.38,7s4.91.73,7.1-1.75,5.26-11,10.25-10.51a9,9,0,0,0-1.41-1.78C354.34,458.25,346.94,456.89,346.94,456.89Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.15,308.6c-4.28,20.33-4.33,56.31-3.66,73.94,0,0,9.34-7.81,24.3-2.57s21.34,5.33,28.87,3,13.43-13.72,35.15-17.73,22.55.53,22.55.53,2.61-5.19-8.26-8.81S419.23,341,412.94,333s-20.8-33.71-23.93-39.79a21.81,21.81,0,0,1-2.4-12.17l-33.77-2.46A221.45,221.45,0,0,0,344.15,308.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.8,255.1l6.1-17c-4.52-4.58-16.28-7.22-16.28-7.22l-14.95,25.06L361.9,232.7c-4.75,1.55-7.31,2.79-8.45,5.42,0,0-2.27,5.87-.79,17.86.41,3.32,1.53,22.5-1.5,28l.06,1.52c19.74,15.37,36.44,12.8,36.44,12.8-.89-2.72-.69-12.13-1.09-14.79.29-3.38.05-5.49,1.49-11.42C388.33,271,393.32,256.21,393.8,255.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.81 283.86 387.23 286.92 387.24 279.85 352.75 276.9 350.81 283.86",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.01,
    y: 327.26,
    width: 24.47,
    height: 22.05,
    rx: 4.45,
    transform: "translate(-86.64 153.61) rotate(-18.81)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.82,339.89a10.89,10.89,0,0,1-2.57-.39,64,64,0,0,1-13.6-5.56.26.26,0,0,1-.11-.34.25.25,0,0,1,.34-.1A64.12,64.12,0,0,0,420.37,339a6.28,6.28,0,0,0,4.19,0,5.36,5.36,0,0,0,2.52-3.23,17.25,17.25,0,0,0,.24-9.93.26.26,0,0,1,.16-.32.26.26,0,0,1,.32.16,18,18,0,0,1-.25,10.26,5.82,5.82,0,0,1-2.78,3.51A4.55,4.55,0,0,1,422.82,339.89Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.85,330.53c-12.34-26.7-24.38-68.16-17.66-97.14l1,.23c-6.66,28.73,5.32,69.94,17.6,96.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.71,318.8a7.06,7.06,0,0,0-3,3.75c-.57,2.29-1.63,4-1.93,5.71s1.54.23,2.36-.77,1.75-2.12,2.4-1.39,2.37,9,3.39,9.92,1.16-.51,1.16-.51.48,2,1.32,2c.22,0,.74-.33.67-1.28-.17-2.12-.74-6.56-.74-6.56,0,.26,1.13,5.69,1.4,6.48.35,1,1,1.34,1.64,1.11.84-.32-.29-7.09-.14-7.41,0,0,.52,3.92,1.61,4.34s.89-2.07.31-4.23c-.54-2-1.08-6-1.82-8-.92-2.41-2.08-3.83-4.49-4A8.3,8.3,0,0,0,413.71,318.8Z",
    style: {
      fill: "#b97964"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelinsuranceRafiki);
export default __webpack_public_path__ + "static/media/Travel insurance-rafiki.b8e841acd16655ac4734f798a90d9e7a.svg";
export { ForwardRef as ReactComponent };